const CONSENT_CHANGED = 'santa:cookie-consent-changed';
const COOKIE_AGREEMENT_KEY = 'cookie_agreement';

export type CookieConsent = 'accepted' | 'rejected';

export function getCookieConsent(): CookieConsent | null {
  const val = window.localStorage.getItem(COOKIE_AGREEMENT_KEY);
  if (val === 'accepted' || val === '1') {
    return 'accepted';
  }
  if (val === 'rejected') {
    return 'rejected';
  }
  return null;
}

export function hasCookieConsentChoice(): boolean {
  return getCookieConsent() !== null;
}

export function getCookieAgreement(): boolean {
  return getCookieConsent() === 'accepted';
}

export function acceptCookies(): void {
  window.localStorage.setItem(COOKIE_AGREEMENT_KEY, 'accepted');
  window.dispatchEvent(new Event(CONSENT_CHANGED));
}

export function rejectCookies(): void {
  window.localStorage.setItem(COOKIE_AGREEMENT_KEY, 'rejected');
  window.dispatchEvent(new Event(CONSENT_CHANGED));
}

export const COOKIE_SETTINGS_EVENT = 'santa:open-cookie-settings';

export function openCookieSettings(): void {
  window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT));
}

export function subscribeCookieSettingsOpen(handler: () => void): () => void {
  window.addEventListener(COOKIE_SETTINGS_EVENT, handler);
  return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, handler);
}

export function subscribeCookieConsent(handler: () => void): () => void {
  window.addEventListener('storage', handler);
  window.addEventListener(CONSENT_CHANGED, handler);
  return () => {
    window.removeEventListener('storage', handler);
    window.removeEventListener(CONSENT_CHANGED, handler);
  };
}
